import React, { useState, useEffect } from 'react';
import ClipLoader from "react-spinners/ClipLoader";
import Comm from '../comm/comm';
import Tools from '../tools/tools';
import { toast } from 'react-toastify';
import ReactJson from 'react-json-view'

const LogSearch = (props) => {
    const pageSize = 20;
    let [date, setDate] = useState("");
    let [userId, setUserId] = useState("0");
    let [users, setUsers] = useState(null);
    let [rows, setRows] = useState(null);

    const fetchData = async () => {
        setUsers(null);
        Comm.Instance().get(`user`).then(result => {
            setUsers(result.data);

        }).catch(error => Tools.ProcessError(error))
    };
    useEffect(() => {

        fetchData();
    }, []);



    const Search = () => {
        if (!date || date === "") {
            toast.error("Моля, изберете дата");
            return;
        }

        setRows([]);
        var data = {
            userId: userId,
            onDate: date
        }

        Comm.Instance().post(`log`, data).then(result => {
            setRows(result.data);

        }).catch(error => Tools.ProcessError(error))
    };


    const collapse = (logId) => {
        let log = rows.filter(x => x.logId === logId)[0];
        if (log.show) {
            log.show = false;
        }
        else {
            log.show = true;
        }
        setRows([...rows]);
    }

    if (!users) {
        return (
            <div className="form-group col-md-12">
                <ClipLoader
                    size={150}
                    color={"#123abc"}
                    loading={!users}
                />
            </div>
        )
    }



    return (

        <div className="container">
            <h2 className="appeal-title mb-5">Търсене</h2>
            <div className="form-row">
                <div className="form-group col-md-4">
                    <label>Дата</label>
                    <input type="date" value={date} onChange={(e) => setDate(e.target.value)} className="form-control" />
                </div>
                <div className="form-group col-md-4">
                    <label>Потребител</label>
                    <select value={userId} onChange={(e) => setUserId(e.target.value)} className="form-control">
                        <option value="0"></option>
                        {
                            users.map(i => <option value={i.username}>{i.fullname}</option>)
                        }
                    </select>
                </div>
                <div className="form-group col-md-4">
                    <button className="btn btn-primary" onClick={() => Search()} style={{ 'bottom': 0, 'position': 'absolute' }}>Търсене</button>
                </div>
            </div>
            {
                rows ?
                    <div className="form-row">
                        <div className="form-group col-md-12">
                            <div className="alert alert-secondary" role="alert">
                                Открити са {rows.length} записа
                            </div>
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th>Потребител</th>
                                        <th>Действие</th>
                                        <th>Описание</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        rows.map(i =>
                                            <tr key={i.logId}>
                                                <td><p>{i.userId}</p><small>{Tools.FormatDate(i.onDate)}</small></td>
                                                <td>{i.action}</td>
                                                <td>
                                                    <button className="btn btn-link" onClick={() => collapse(i.logId)}>...</button>
                                                    {
                                                        i.show ?
                                                            <ReactJson src={JSON.parse(i.data)} />
                                                            : null
                                                    }
                                                </td>

                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    : null
            }


        </div>

    );
}


export default LogSearch;